export const statsOrder = [
    'goals',
    'points',
    'shots_on_goal',
    'shots_on_goal_1_period',
    'shots_on_goal_2_period',
    'shots_on_goal_3_period',
    'shots_on_goal_overtime',
    'shootings_percentage',
    'blockings',
    'power_play_goals',
    'power_play_opportunities',
    'powerplay_percentage',
    'penalty_in_minutes',
    'goals_against_in_penalty_killing',
    'penalty_killing_percentage',
    'faceoff_total',
    'faceoffs_won',
    'faceoffs_lost',
    'faceoff_percentage',
];

export const labelMap = {
    goals: 'Goals',
    goals_against: 'Goals Against',
    points: 'Points',
    shots_on_goal: 'Shots Total',
    shots_on_goal_1_period: 'Shots 1st Period',
    shots_on_goal_2_period: 'Shots 2nd Period',
    shots_on_goal_3_period: 'Shots 3rd Period',
    shots_on_goal_overtime: 'Shots on Goal (OT)',
    shootings_percentage: 'Shooting %',
    power_play_opportunities: 'Powerplay Opportunities',
    power_play_goals: 'Powerplay Goals',
    powerplay_percentage: 'Powerplay %',
    penalty_in_minutes: 'Time in Penalty Killing',
    blockings: 'Blocked Shots',
    faceoffs_won: 'Faceoffs Won',
    faceoffs_lost: 'Faceoffs Lost',
    faceoff_total: 'Total Faceoffs',
    faceoff_percentage: 'Faceoff %',
    goals_against_in_penalty_killing: 'Goals against in Penalty Killing',
    penalty_killing_percentage: 'Penalty Killing %',
};
